import h from 'virtual-dom/h';
import { DefaultSettings, settings } from "../../../../settings/settings-util";
import { Store } from "redux";
import { AlmeState, defaultState } from "../../../../wireup/AlmeState";
import { VChild } from "virtual-dom";
import EndChatWarningOverlay from "../../../livechat-endchat-warning-overlay/src/end-chat-warning-overlay";
import LiveChatState from "../livechat-state";


export default class EndChatLinkRenderer {

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _stateManager: LiveChatState;
    _endChatWarningOverlay: EndChatWarningOverlay;


    //#region Public Interface

    constructor(settings: DefaultSettings, state: LiveChatState, endChatWarningOverlay: EndChatWarningOverlay) {
        this._settings = settings;
        this._stateManager = state;
        this._endChatWarningOverlay = endChatWarningOverlay;
    }

    initialize(store: Store<AlmeState>): void {
        this._store = store;
    }

    getReducer() {
        return (state = defaultState): AlmeState => state;
    }

    getRenderer() {
        return (): VChild => {
            if (!this._stateManager.isOnline) { return []; }

            const { endChatLinkContainer, endChatLink } = this._settings.classNames.livechat;
            const { endChatLinkText, endChatLinkToolTip } = this._settings.livechat.textConstants;
            const submitKey =  settings.textConstants.submitKey || this._settings.textConstants.submitKey;
            const divProperties = {
                className: endChatLink,
                role: 'button',
                'aria-label': endChatLinkToolTip,
                onclick: (): void => {
                    if (this._settings.endChatWarning?.isWarningEnabled) {
                        this._endChatWarningOverlay.showWarningOrEndChat();
                    }
                    else {
                        this._stateManager.endChat('User', 'Click');
                    }
                },
                onkeyup: (e: KeyboardEvent): void => {
                    if (e.key === submitKey) {
                        if (this._settings.endChatWarning?.isWarningEnabled) {
                            this._endChatWarningOverlay.showWarningOrEndChat();
                        }
                        else {
                            this._stateManager.endChat('User', 'Click');
                        }
                    }
                },
                tabIndex: "0",
            };
            const div = h('div', divProperties, endChatLinkText);

            return h('div', { className: endChatLinkContainer }, [div]);
        };
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/renderers/endchat-link-renderer.ts